import dio, { DioContext, DioType } from './init';

export default {
  webWidgetOpened() {
    dio.track('web_widget_opened', DioType.CLICK, {}, DioContext.ZENDESK);
  },
  helpCenterShown() {
    dio.track('help_center_shown', DioType.CLICK, {}, DioContext.ZENDESK);
  },
  helpCenterSearch(data: any) {
    dio.track('help_center_search', DioType.CLICK, data, DioContext.ZENDESK);
  },
  helpCenterArticleViewed(data: any) {
    dio.track(
      'help_center_article_viewed',
      DioType.CLICK,
      data,
      DioContext.ZENDESK
    );
  },
  helpCenterViewOriginalArticleClicked(data: any) {
    dio.track(
      'help_center_view_original_article_clicked',
      DioType.CLICK,
      data,
      DioContext.ZENDESK
    );
  },
  contactFormShown() {
    dio.track('contact_form_shown', DioType.CLICK, {}, DioContext.ZENDESK);
  },
  contactFormSubmitted() {
    dio.track('contact_form_submitted', DioType.CLICK, {}, DioContext.ZENDESK);
  },
  webWidgetMinimised() {
    dio.track('web_widget_minimised', DioType.CLICK, {}, DioContext.ZENDESK);
  },
};
